module.exports = __webpack_public_path__ + "static/media/newsletter-december-2023-1.a72a08be.jpg";